import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  top: 40vh;
  left: 50%;
  margin-left:-10rem;
`;
